module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Exodus-Gods-&-Kings.a9d5cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Exodus-Gods-&-Kings.jpg
// module id = H6ZX
// module chunks = 0